import {
  ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD_V2,
  ROUTE_PAYMENT_VERIFY_PAYMENT_V2,
  ROUTE_PPRA,
  ROUTE_PPRA_MEMBERSHIP_INTERSTITIAL,
  ROUTE_PPRA_PAYMENT,
  ROUTE_PPRA_QUESTIONNAIRE,
  ROUTE_PPRA_RESULTS,
  ROUTE_PPRA_RESULTS_LOADING,
  ROUTE_PPRA_RESULTS_PDP,
} from '@/constants/routes';
import { getRoute } from '@/utils';
import setTitleFromLoader from '@/utils/routing/set-title';
import { Navigate, RouteObject } from 'react-router-dom';
import VerifyPaymentPageV2 from '../payment/components/verify/payment-verify-v2.page';
import PPRALoadingScreen from './components/ppra-loading-page/ppraLoadingScreen';
import { PPRAMembershipInterstitialPage } from './components/ppra-membership-page/PPRAMembershipInterstitial.page';
import { PaymentForm as LegacyPaymentForm } from './components/ppra-payment-page/PPRAPaymentPage';
import { PPRAPaymentPageWrapper } from '../payment-page-v2/PaymentPageWrapper';
import PPRAResultsLoadingPage from './components/ppra-results-loading-page/ppra-results-loading.page';
import PpraResultsPage from './components/ppra-results-page/ppra-results.page';
import Page from './ppra.page';

export const routePpra: RouteObject = {
  path: ROUTE_PPRA,
  Component: PPRALoadingScreen,
  loader: setTitleFromLoader('Free Risk Assessment'),
};

export const routePpraQuestionnaire: RouteObject = {
  path: ROUTE_PPRA_QUESTIONNAIRE,
  Component: Page,
  loader: setTitleFromLoader('Free Risk Assessment'),
};

export const routePaymentCollectPaymentMethodV2: RouteObject = {
  path: ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD_V2,
  Component: LegacyPaymentForm,
  loader: setTitleFromLoader('Catch Membership'),
};

export const routePaymentVerifyV2: RouteObject = {
  path: ROUTE_PAYMENT_VERIFY_PAYMENT_V2,
  Component: VerifyPaymentPageV2,
  loader: setTitleFromLoader('Catch Membership'),
};

export const routePpraPayment: RouteObject = {
  path: ROUTE_PPRA_PAYMENT,
  Component: PPRAPaymentPageWrapper,
  children: [
    { index: true, element: <Navigate to={getRoute(ROUTE_PAYMENT_COLLECT_PAYMENT_METHOD_V2)} replace /> },
    routePaymentCollectPaymentMethodV2,
    routePaymentVerifyV2,
  ],
  loader: setTitleFromLoader('Catch Membership'),
};

export const routePpraResults: RouteObject = {
  path: ROUTE_PPRA_RESULTS,
  Component: PpraResultsPage,
  loader: setTitleFromLoader('Your Risk Assessment Results'),
};

export const routePpraResultsPdp: RouteObject = {
  path: ROUTE_PPRA_RESULTS_PDP,
  Component: PpraResultsPage,
  loader: setTitleFromLoader('Your Risk Assessment Results'),
};

export const routePpraResultsLoading: RouteObject = {
  path: ROUTE_PPRA_RESULTS_LOADING,
  Component: PPRAResultsLoadingPage,
  loader: setTitleFromLoader('Processing Your Results'),
};

export const routePpraMembershipInterstitial: RouteObject = {
  path: ROUTE_PPRA_MEMBERSHIP_INTERSTITIAL,
  Component: PPRAMembershipInterstitialPage,
  loader: setTitleFromLoader('Catch Membership'),
};
